import 'regenerator-runtime/runtime';

const path = require('path');
const fs = require('fs');
const _get = require('lodash/get');
// const pino = require('pino');
const isNode = require('../ajio-util/isNode');

const { LOG_FILE_NAME, RELATIVE_LOG_PATH } = require('./config');

const STRIPPED_URL_PATTERN = /[?#]/;

const getStrippedUrl = endpoint => endpoint.split(STRIPPED_URL_PATTERN)[0];

class Logger {
  constructor() {
    // this.loggerInstance = {};
    // this.pinoOptions = { base: null };

    // this.loggerInstance = pino(this.pinoOptions, this.elkLogPath);
    if (isNode()) {
      const processName = _get(process, 'env.MICRO_SERVER', 'homerefresh');
      this.pidFilePath = path.join(__dirname, `${RELATIVE_LOG_PATH}/file-${processName}.pid`);
      this.elkLogPath = path.join(__dirname, `${RELATIVE_LOG_PATH}/${LOG_FILE_NAME}`);
      fs.appendFileSync(this.elkLogPath, '');
      this.writeStreamInstance = fs.createWriteStream(this.elkLogPath, { flags: 'a' });
      const errCallback = () => {
        if (this.writeStreamInstance) {
          this.writeStreamInstance.end();
        }
        this.writeStreamInstance = fs.createWriteStream(this.elkLogPath, { flags: 'a' });
        this.writeStreamInstance.on('error', errCallback);
      };
      this.writeStreamInstance.on('error', errCallback);
      fs.writeFile(this.pidFilePath, `${process.pid}`, err => {
        if (err) {
          console.log('Error in writing to pid file-->', err);
        }
      });
      process.on('SIGUSR2', () => {
        if (this.writeStreamInstance) {
          this.writeStreamInstance.end();
        }
        // eslint-disable-next-line global-require
        const accessLogStream = require('../../../server/accessLogStream');
        accessLogStream.resetFileStream();
        this.writeStreamInstance = fs.createWriteStream(this.elkLogPath, { flags: 'a' });
        this.writeStreamInstance.on('error', errCallback);
        // this.loggerInstance = pino(this.pinoOptions, this.elkLogPath);
      });
    }
  }

  logCorrectResponse = async ({
    response,
    basicLogObject,
    baseVerboseObject,
    isVerbose,
    headers,
    isUATEnv
  }) => {
    let derivedVerboseObject = {};
    try {
      if (isVerbose && isUATEnv) {
        const responseCopy = await response.clone();
        const jsonResponse = await responseCopy.json();
        derivedVerboseObject = {
          ...baseVerboseObject,
          requestHeader: headers,
          responseBody: jsonResponse
        };
      }
      this.writeStreamInstance.write(
        `${JSON.stringify({
          ...basicLogObject,
          ...derivedVerboseObject
        })}\n`
      );
      /*
      this.loggerInstance.info({
        ...basicLogObject,
        ...derivedVerboseObject
      });
      */
    } catch (error) {
      try {
        const { endpoint = '' } = basicLogObject;
        this.writeStreamInstance.write(
          `${JSON.stringify({
            ...basicLogObject,
            ...derivedVerboseObject,
            type: 'error',
            errorBody: JSON.stringify({ message: 'Failed to Parse JSON from body' }),
            errorMessage: error.message
              ? error.message
              : `${endpoint} : Failed to Parse message from error`,
            errorType: _get(error, 'type', '')
          })}\n`
        );
      } catch (err) {}

      /* this.loggerInstance.error({
        ...basicLogObject,
        ...derivedVerboseObject,
        type: 'error',
        errorBody: JSON.stringify({ message: 'Failed to Parse JSON from body' }),
        errorMessage: _get(error, 'message', ''),
        errorType: _get(error, 'type', '')
      }); */
    }
  };

  logIncorrectResponse = async ({
    response,
    basicLogObject,
    baseVerboseObject,
    isVerbose,
    headers,
    isUATEnv
  }) => {
    let derivedVerboseObject = {};
    const { endpoint = '' } = basicLogObject;
    try {
      if (isVerbose && isUATEnv) {
        const responseCopy = await response.clone();
        const jsonResponse = await responseCopy.json();
        derivedVerboseObject = {
          ...baseVerboseObject,
          requestHeaders: headers,
          errorBody: JSON.stringify(jsonResponse)
        };
      }
      /*
      this.loggerInstance.error({
        ...basicLogObject,
        ...derivedVerboseObject,
        type: 'error'
      });
      */
      this.writeStreamInstance.write(
        `${JSON.stringify({
          ...basicLogObject,
          ...derivedVerboseObject,
          type: 'error',
          errorMessage: `${endpoint} : ${derivedVerboseObject.errorBody}`
        })}\n`
      );
    } catch (error) {
      derivedVerboseObject = {
        ...baseVerboseObject
      };
      this.writeStreamInstance.write(
        `${JSON.stringify({
          ...basicLogObject,
          ...derivedVerboseObject,
          type: 'error',
          errorBody: JSON.stringify({ message: 'Failed to Parse JSON from body' }),
          errorMessage: error.message
            ? error.message
            : `${endpoint} : Failed to Parse message from error`,
          errorType: _get(error, 'type', '')
        })}\n`
      );
      /*
      this.loggerInstance.error({
        ...basicLogObject,
        ...derivedVerboseObject,
        type: 'error',
        errorBody: JSON.stringify({ message: 'Failed to Parse JSON from body' }),
        errorMessage: _get(error, 'message', ''),
        errorType: _get(error, 'type', '')
      });
      */
    }
  };

  logFetcherInfo = (args, response, responseTime) => {
    const isVerbose = _get(global, '__LOGGER_VERBOSE__', 'OFF') === 'ON';
    return new Promise((resolve, reject) => {
      const url = _get(args, [0], 'UnknownUrl');
      const referer = _get(args, '[1].headers.referer', '');
      const clientIP = _get(args, '[1].headers.clientIP', '');
      const strippedUrl = getStrippedUrl(url);
      const status = _get(response, 'status', '5xx');
      const userCohortValues = _get(args, '[1].headers.userCohortValues', '');

      // To Maintain a generic Verbose object across logs
      let basicVerboseObject = {};
      const basicLogObject = {
        time: Date.now(),
        type: 'info',
        endpoint: url,
        strippedUrl,
        statusCode: status,
        responseTimeMillis: responseTime,
        referer,
        clientIP,
        ...(userCohortValues && { userCohortValues }),
      };
      const isUATEnv = ['uat52', 'uat62'].includes(process.env.NODE_CONFIG_ENV);
      const logParams = {
        response,
        basicLogObject,
        basicVerboseObject,
        isVerbose,
        headers: args[1]?.headers,
        isUATEnv
      };
      try {
        const { status: resStatus } = response;
        if (resStatus >= 200 && resStatus < 399) {
          this.logCorrectResponse(logParams);
          resolve('Logged');
        } else {
          this.logIncorrectResponse(logParams);
          resolve('Logged');
        }
      } catch (err) {
        basicVerboseObject = {
          ...basicVerboseObject,
          errorBody: JSON.stringify({ message: 'Failed to Parse JSON from body' })
        };
        this.writeStreamInstance.write(
          `${JSON.stringify({
            ...basicLogObject,
            ...basicVerboseObject,
            type: 'error',
            errorMessage: err.message ? err.message : `${url} : Failed to Parse message from error`,
            errorType: _get(err, 'type', '')
          })}\n`
        );
        /* this.loggerInstance.error({
          ...basicLogObject,
          ...basicVerboseObject,
          type: 'error',
          errorMessage: _get(err, 'message', ''),
          errorType: _get(err, 'type', '')
        }); */
        resolve('Logged');
      }
    });
  };

  logFetcherError = (args, error, responseTime) => {
    return new Promise((resolve, reject) => {
      const url = _get(args, [0], 'UnknownUrl');
      const strippedUrl = getStrippedUrl(url);
      const status = _get(error, 'status', '5xx');
      const message = error.message ? error.message : `${url} : Failed to Parse message from error`;
      const name = _get(error, 'name', '');
      const errorType = _get(error, 'type', '');
      const basicLogObject = {
        time: Date.now(),
        type: 'error',
        endpoint: url,
        strippedUrl,
        statusCode: status,
        responseTimeMillis: responseTime
      };
      try {
        this.writeStreamInstance.write(
          `${JSON.stringify({
            ...basicLogObject,
            errorMessage: message,
            nameInError: name,
            errorType
          })}\n`
        );
      } catch (error) {}
      /* this.loggerInstance.error({
        ...basicLogObject,
        errorMessage: message,
        nameInError: name,
        errorType
      }); */
      resolve('Logged');
    });
  };
}

const logger = new Logger();

export default logger;
